import script from "./TagGlyphPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TagGlyphPicker.vue?vue&type=script&setup=true&lang=js"

import "./TagGlyphPicker.vue?vue&type=style&index=0&id=74c7d24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c7d24e"]])

export default __exports__